import React, { useState } from 'react';
import { Radio } from 'antd';
import { ButtonLabel, RadioButtonComponent } from './radio-tabs.styles';

interface IRadioTabsProps {
  tabs: {
    tabTitle: string;
    tabContent: React.ReactNode;
    tabIcon?: React.ReactNode;
    onSelect: () => void;
  }[];
  selectedTab?: number;
}

export const RadioTabs = ({
  tabs,
  selectedTab: initialSelectedTab,
}: IRadioTabsProps) => {
  const [selectedTab, setSelectedTab] = useState(initialSelectedTab ?? 0);
  return (
    <>
      <RadioButtonComponent numberOfTabs={tabs.length}>
        <Radio.Group
          value={initialSelectedTab ?? selectedTab}
          onChange={(e) => setSelectedTab(e.target.value)}
        >
          {tabs.map((tab, index) => (
            <Radio.Button
              onClick={tab?.onSelect}
              data-testid={`radio-${index}`}
              value={index}
              key={index}
            >
              <ButtonLabel>
                {tab.tabTitle} {tab.tabIcon}
              </ButtonLabel>
            </Radio.Button>
          ))}
        </Radio.Group>
      </RadioButtonComponent>
      <div>{tabs[selectedTab].tabContent}</div>
    </>
  );
};
